import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed tracking-wide';
  const variants = {
    primary: 'bg-brand-clay text-white hover:bg-[#C89268] hover:shadow-lg hover:shadow-brand-clay/30 focus:ring-brand-clay border border-transparent',
    secondary: 'bg-brand-eucalyptus text-brand-dark hover:bg-[#C0C8A0] hover:shadow-lg hover:shadow-brand-eucalyptus/30 focus:ring-brand-eucalyptus border border-transparent',
    outline: 'bg-transparent border-2 border-brand-clay text-brand-clay hover:bg-brand-clay/10 focus:ring-brand-clay',
    ghost: 'bg-transparent text-brand-clay hover:bg-brand-clay/10 focus:ring-brand-clay'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-32">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-33" />}
      {children}
    </button>;
}